class SystemHelper {
    static isProd() {
        return process.env.NODE_ENV === 'production';
    }

    static isDev() {
        return process.env.NODE_ENV === 'development';
    }
}

export { SystemHelper };
